import { createVNode as _createVNode } from "vue";
import { IconWrapper } from '../runtime';
export default IconWrapper('composition', true, function (props) {
  return _createVNode("svg", {
    "width": props.size,
    "height": props.size,
    "viewBox": "0 0 48 48",
    "fill": "none"
  }, [_createVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    "d": "M39.8281 21.786L21.9686 39.6455C18.5544 43.0598 12.9373 42.9784 9.42255 39.4637C5.90784 35.949 5.82643 30.3319 9.24073 26.9176L27.1002 9.05809",
    "fill": props.colors[1]
  }, null), _createVNode("path", {
    "d": "M39.8281 21.786L21.9686 39.6455C18.5544 43.0598 12.9373 42.9784 9.42255 39.4637C5.90784 35.949 5.82643 30.3319 9.24073 26.9176L27.1002 9.05809",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null), _createVNode("path", {
    "d": "M8.73438 27.4239L34.8784 26.7357",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null), _createVNode("path", {
    "d": "M29.393 20.907C30.1741 20.1259 30.1741 18.8596 29.393 18.0786C28.612 17.2975 27.3457 17.2975 26.5646 18.0786C25.7836 18.8596 25.7836 20.1259 26.5646 20.907C27.3457 21.688 28.612 21.688 29.393 20.907Z",
    "fill": props.colors[2]
  }, null), _createVNode("path", {
    "d": "M23.7358 23.7356C24.5169 22.9546 24.5169 21.6882 23.7358 20.9072C22.9548 20.1261 21.6884 20.1261 20.9074 20.9072C20.1263 21.6882 20.1263 22.9546 20.9074 23.7356C21.6884 24.5167 22.9548 24.5167 23.7358 23.7356Z",
    "fill": props.colors[2]
  }, null), _createVNode("path", {
    "d": "M23.5645 5.52257L43.3634 25.3216",
    "stroke": props.colors[0],
    "stroke-width": props.strokeWidth,
    "stroke-linecap": props.strokeLinecap
  }, null)]);
});